import { defineMessages } from 'react-intl';

const translations = {
  yes: {
    id: 'properties.yes',
    defaultMessage: 'Yes',
    description: 'Property translation for yes',
  },
  no: {
    id: 'properties.no',
    defaultMessage: 'No',
    description: 'Property translation for no',
  },
  fields: {
    number: {
      label: {
        id: 'properties.invoiceNumber',
        defaultMessage: 'Invoice number',
        description: 'Label of the invoice number field',
      },
    },
    customer: {
      label: {
        id: 'properties.customer',
        defaultMessage: 'Customer',
        description: 'Label of the customer field',
      },
    },
    organisation: {
      label: {
        id: 'properties.organisation',
        defaultMessage: 'Organisation',
        description: 'Label of the organisation field',
      },
    },
    client: {
      label: {
        id: 'properties.client',
        defaultMessage: 'Client',
        description: 'Label of the client field',
      },
    },
    isConcept: {
      label: {
        id: 'properties.isConcept',
        defaultMessage: 'Concept',
        description: 'Label of the is concept field',
      },
    },
    isPaid: {
      label: {
        id: 'properties.isPaid',
        defaultMessage: 'Paid',
        description: 'Label of the is paid field',
      },
    },
    paidAt: {
      label: {
        id: 'properties.paidAt',
        defaultMessage: 'Paid at',
        description: 'Label of the paid at field',
      },
    },
    createdAt: {
      label: {
        id: 'properties.createdAt',
        defaultMessage: 'Created at',
        description: 'Label of the created at field',
      },
    },
    isIncludingVat: {
      label: {
        id: 'properties.isIncludingVat',
        defaultMessage: 'Including VAT',
        description: 'Label of the is including vat field',
      },
    },
    subtotal: {
      label: {
        id: 'properties.subtotal',
        defaultMessage: 'Subtotal',
        description: 'Label of the subtotal field',
      },
    },
    total: {
      label: {
        id: 'properties.total',
        defaultMessage: 'Total',
        description: 'Label of the total field',
      },
    },
    billingAddress: {
      label: {
        id: 'properties.billingAddress',
        defaultMessage: 'Billing address',
        description: 'Label of the billing address field',
      },
    },
  },
};

export default defineMessages(translations);
